import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import './MetricCard.css';

const MetricCard = ({ color, text, number, onClick }) => (
  <div className='metricCardContainer' style={{ borderLeft: `4px solid ${color}` }} onClick={onClick}>
    <div className='metricCardInnerContainer'>
      <div className='flex-1' style={{ alignItems: 'center' }}>
        <Typography type='header' style={{ fontSize: 12 }}>{text}</Typography>
      </div>
      <div className='flex' style={{ justifyContent: 'center', marginLeft: 8 }}>
        <Typography title='header' style={{ color, fontSize: '2rem' }}>{number}</Typography>
      </div>
    </div>
  </div>
);

MetricCard.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string,
  number: PropTypes.string,
  onClick: PropTypes.func
};

export default MetricCard;
